/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Two_Fa_Already_EnabledInputs */

const en_two_fa_already_enabled = /** @type {(inputs: Two_Fa_Already_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Two-factor authentication is already enabled`)
};

const nl_two_fa_already_enabled = /** @type {(inputs: Two_Fa_Already_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twee-factor-authenticatie is al ingeschakeld`)
};

/**
* | output |
* | --- |
* | "Two-factor authentication is already enabled" |
*
* @param {Two_Fa_Already_EnabledInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const two_fa_already_enabled = /** @type {((inputs?: Two_Fa_Already_EnabledInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Two_Fa_Already_EnabledInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_two_fa_already_enabled(inputs)
	return en_two_fa_already_enabled(inputs)
});